import { render, staticRenderFns } from "./video.vue?vue&type=template&id=f45ca8e8&scoped=true&"
import script from "./video.vue?vue&type=script&lang=js&"
export * from "./video.vue?vue&type=script&lang=js&"
import style0 from "./video.vue?vue&type=style&index=0&id=f45ca8e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45ca8e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f45ca8e8')) {
      api.createRecord('f45ca8e8', component.options)
    } else {
      api.reload('f45ca8e8', component.options)
    }
    module.hot.accept("./video.vue?vue&type=template&id=f45ca8e8&scoped=true&", function () {
      api.rerender('f45ca8e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/social/search/video.vue"
export default component.exports